function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata5"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-275.83332)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path825",
  d: "m 47.029297,286.20508 a 1.366005,1.366005 0 0 0 -1.111328,0.68164 l -14.990235,25.96484 -14.992187,25.96485 a 1.366005,1.366005 0 0 0 1.183594,2.04882 h 29.982421 29.980469 a 1.366005,1.366005 0 0 0 1.183594,-2.04882 L 63.275391,312.85156 48.283203,286.88672 a 1.366005,1.366005 0 0 0 -1.253906,-0.68164 z m 0.07227,4.0957 13.806641,23.91602 13.808594,23.91601 H 47.101562 19.484375 L 33.292969,314.2168 Z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path829",
  d: "m 46.712891,20.066406 a 1.6940581,1.6940581 0 0 0 -1.667969,1.71875 v 26.109375 a 1.6940581,1.6940581 0 1 0 3.386719,0 V 21.785156 a 1.6940581,1.6940581 0 0 0 -1.71875,-1.71875 z"
}), /*#__PURE__*/React.createElement("circle", {
  r: 3.0393755,
  cy: 54.960587,
  cx: 46.614819,
  id: "path831"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "layer3"
}, /*#__PURE__*/React.createElement("path", {
  id: "path964-7",
  d: "m 0.18516856,52.635234 c 5.02340794,0 9.72988844,-2.526803 12.33007844,-6.789059 2.60019,-4.262257 2.60019,-9.651808 0,-13.914064 C 9.915057,27.669856 5.2085765,25.143049 0.18516856,25.143049 v 8.089844 c 2.30083294,0 4.36384694,1.171379 5.42578094,2.912109 1.06193,1.740732 1.06193,3.747551 0,5.488281 -1.061934,1.740729 -3.124948,2.912111 -5.42578094,2.912111 z"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "scale(-1,1)",
  ry: 0.00000359872,
  y: 34.666481,
  x: -25.872793,
  height: 7.8125005,
  width: 12.45376,
  id: "rect962"
}));

var SvgWarnSignal = function SvgWarnSignal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarnSignal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warn-signal.cbf435f5.svg";
export { ForwardRef as ReactComponent };